import { Component, OnInit } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { ServiceObject } from 'src/app/models/service-object';
import { WebAPIService } from 'src/app/services/web-api.service';

@Component({
  selector: 'app-horary-day-report',
  templateUrl: './horary-day-report.component.html',
  styleUrls: ['./horary-day-report.component.scss']
})
export class HoraryDayReportComponent implements OnInit {

  isLoading: boolean = false;
  reportHorary: any = [];

  barChartOptions: ChartOptions = {
    responsive: true,
  };
  barChartLabels!: Label[];
  barChartType: ChartType = 'line';
  barChartLegend = true;
  barChartPlugins = [];
  barChartData!: ChartDataSets[];

  constructor(private webAPI: WebAPIService) { }

  ngOnInit(): void {
  }

  onChange(e: any) {
    if (e) {
      var date = e.target.value.split("-");
      this.isLoading = false;
      var servObj = new ServiceObject("report/horaryDay/" + date[2] + "/" + date[1] + "/" + date[0]);
      this.webAPI.GetAction(servObj)
        .then(x => {
          servObj = <ServiceObject>x;
          var values: any = [];
          this.reportHorary = x.data.report;
          this.barChartLabels = Object.keys(this.reportHorary[0]);
          Object.keys(this.reportHorary[0]).forEach((element: any) => {
            values.push(this.reportHorary[0][element]);
          });
          this.barChartData = [
            { data: values, label: 'Casos por día' }
          ];
          this.isLoading = true;
        }).catch(x => { throw x.message; });
    }
  }

}
